import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { VIKAS_KAME_CHART_CONSTANT } from "../constants/vikaskame.constant";

@Injectable({
  providedIn: "root",
})
export class VikasKameService {
  constructor(private http: HttpClient) {}

  public getVikasKameChartData() {
    return this.http.get(`${VIKAS_KAME_CHART_CONSTANT.VIKAS_KAME_COUNT}`);
  }
}
